// src/components/ContentSection.js

import React from 'react';

const ContentSection = ({ title, text, imageSrc, imageAlt, imagePosition = 'left', className = '' }) => {
  // Yeni çerçeveli resim sütunu
  const imageColumn = (
    <div className="col-lg-6 d-flex align-items-center justify-content-center mb-4 mb-lg-0">
      <div className="framed-image-wrapper">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="img-fluid rounded" // shadow-lg kaldırıldı
          loading="lazy"
        />
      </div>
    </div>
  );

  const textColumn = (
    <div className="col-lg-6">
      <h2 className="cb-title mb-3">{title}</h2>
      <div className="cb-content">
        <p>{text}</p>
      </div>
    </div>
  );

  return (
    // Dışarıdan gelen className'i section'a ekliyoruz
    <section className={`content-section ${className}`}>
      <div className="container">
        <div className="row align-items-center">
          {imagePosition === 'left' ? (
            <>
              {imageColumn}
              {textColumn}
            </>
          ) : (
            <>
              {textColumn}
              {imageColumn}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;